/* eslint-disable no-unused-vars */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { FunctionComponent, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useStore } from '../../store';

interface ISectionProps {
  settings: any;
  components: { [key: string]: FunctionComponent<any> };
}

const TopicSection: React.FunctionComponent<ISectionProps> = ({
  settings,
  components,
}) => {
  return (
    <>
      {settings?.map((itm: any, index: number) => {
        const Component = components[itm.component] as FunctionComponent<any>;
        return <Component key={itm.component + index} {...itm} />;
      })}
    </>
  );
};
export default TopicSection;
